var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1667,
    height: 2500,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.833 2500c230 0 416.667-186.67 416.667-416.67v-416.66H416.833c-230 0-416.666 186.66-416.666 416.66 0 230 186.666 416.67 416.666 416.67Z",
    fill: "#252B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.167 1250c0-230 186.666-416.667 416.666-416.667H833.5v833.337H416.833C186.833 1666.67.167 1480 .167 1250ZM.167 416.667C.167 186.667 186.833 0 416.833 0H833.5v833.333H416.833c-230 0-416.666-186.666-416.666-416.666ZM833.5 0h416.67c230 0 416.66 186.667 416.66 416.667 0 230-186.66 416.666-416.66 416.666H833.5V0Z",
    fill: "#252B33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1666.83 1250c0 230-186.66 416.67-416.66 416.67-230 0-416.67-186.67-416.67-416.67 0-230 186.67-416.667 416.67-416.667 230 0 416.66 186.667 416.66 416.667Z",
    fill: "#252B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.016a06b0111e21a243d16be2dcc8a6ea.svg";
export { ForwardRef as ReactComponent };